"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _ncUpgradeErrors = require("~/version-upgrader/ncUpgradeErrors");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _Source = /*#__PURE__*/ _interop_require_default(require("~/models/Source"));
const _globals = require("~/utils/globals");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// after 0101002 upgrader, the attachment object would become broken when
// (1) switching views after updating a singleSelect field
// since `url` will be enriched the attachment cell, and `saveOrUpdateRecords` in Grid.vue will be triggered
// in this way, the attachment value will be corrupted like
// {"{\"path\":\"download/noco/xcdb2/attachment2/a/JRubxMQgPlcumdm3jL.jpeg\",\"title\":\"haha.jpeg\",\"mimetype\":\"image/jpeg\",\"size\":6494,\"url\":\"http://localhost:8080/download/noco/xcdb2/attachment2/a/JRubxMQgPlcumdm3jL.jpeg\"}"}
// while the expected one is
// [{"path":"download/noco/xcdb2/attachment2/a/JRubxMQgPlcumdm3jL.jpeg","title":"haha.jpeg","mimetype":"image/jpeg","size":6494}]
// (2) or reordering attachments
// since the incoming value is not string, the value will be broken
// hence, this upgrader is to revert back these corrupted values
function getTnPath(knex, tb) {
    const clientType = knex.clientType();
    if (clientType === 'snowflake') {
        return [
            knex.client.config.connection.database,
            knex.client.config.connection.schema,
            tb.table_name
        ].join('.');
    } else {
        return tb.table_name;
    }
}
async function _default({ ncMeta }) {
    const sources = await ncMeta.knexConnection(_globals.MetaTable.SOURCES);
    for (const _base of sources){
        const source = new _Source.default(_base);
        // skip if the base_id is missing
        if (!source.base_id) {
            continue;
        }
        const context = {
            workspace_id: source.fk_workspace_id,
            base_id: source.base_id
        };
        const base = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.PROJECT, {
            id: source.base_id
        });
        // skip if the base is missing
        if (!base) {
            continue;
        }
        const isProjectDeleted = base.deleted;
        const knex = source.is_meta ? ncMeta.knexConnection : await _NcConnectionMgrv2.default.get(source);
        const models = await source.getModels(context, ncMeta);
        // used in timeout error message
        const timeoutErrorInfo = {
            baseTitle: base.title,
            connection: knex.client.config.connection
        };
        for (const model of models){
            try {
                // if the table is missing in database, skip
                if (!await knex.schema.hasTable(getTnPath(knex, model))) {
                    continue;
                }
                const updateRecords = [];
                // get all attachment & primary key columns
                // and filter out the columns that are missing in database
                const columns = await (await _Model.default.get(context, model.id, ncMeta)).getColumns(context, ncMeta).then(async (columns)=>{
                    const filteredColumns = [];
                    for (const column of columns){
                        if (column.uidt !== _nocodbsdk.UITypes.Attachment && !column.pk) continue;
                        if (!await knex.schema.hasColumn(getTnPath(knex, model), column.column_name)) continue;
                        filteredColumns.push(column);
                    }
                    return filteredColumns;
                });
                const attachmentColumns = columns.filter((c)=>c.uidt === _nocodbsdk.UITypes.Attachment).map((c)=>c.column_name);
                if (attachmentColumns.length === 0) {
                    continue;
                }
                const primaryKeys = columns.filter((c)=>c.pk).map((c)=>c.column_name);
                const records = await knex(getTnPath(knex, model)).select();
                for (const record of records){
                    const where = primaryKeys.map((key)=>{
                        return {
                            [key]: record[key]
                        };
                    }).reduce((acc, val)=>Object.assign(acc, val), {});
                    for (const attachmentColumn of attachmentColumns){
                        if (typeof record[attachmentColumn] === 'string') {
                            // potentially corrupted
                            try {
                                JSON.parse(record[attachmentColumn]);
                                continue;
                            } catch (unused) {
                                try {
                                    // corrupted
                                    let corruptedAttachment = record[attachmentColumn];
                                    // replace the first and last character with `[` and `]`
                                    // and parse it again
                                    corruptedAttachment = JSON.parse(`[${corruptedAttachment.slice(1, corruptedAttachment.length - 1)}]`);
                                    const newAttachmentMeta = [];
                                    for (const attachment of corruptedAttachment){
                                        newAttachmentMeta.push(JSON.parse(attachment));
                                    }
                                    updateRecords.push(await knex(getTnPath(knex, model)).update({
                                        [attachmentColumn]: JSON.stringify(newAttachmentMeta)
                                    }).where(where));
                                } catch (unused) {
                                    continue;
                                }
                            }
                        }
                    }
                }
                await Promise.all(updateRecords);
            } catch (e) {
                // ignore the error related to deleted base
                if (!isProjectDeleted) {
                    // throw the custom timeout error message if applicable
                    (0, _ncUpgradeErrors.throwTimeoutError)(e, timeoutErrorInfo);
                    // throw general error
                    throw e;
                }
            }
        }
    }
}
